import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
import {
    IReportDataResponse,
    ILeadsReportsParams,
    ILeadsReportsCsvResponse,
    ISummaryResponse,
    ILeadsReportsDataResponse,
    ISalesReportsCsvResponse
} from '~/components/Reports/types/reports.types';
import { ReportFiltersType } from '~/components/Reports/types/reports.types';
export class ReportsAdapter extends BaseHttpAdapter {
    async getLeadsReportsCsv(userId: string, user_data: ILeadsReportsParams) {
        return this.apiService.apiRequest<ILeadsReportsCsvResponse>({
            method: 'get',
            url: `/api/v2/reporting/users/${userId}/reports/csv/leads`,
            params: user_data
        });
    }

    async getLeadsReportsData(userId: string, user_data: ILeadsReportsParams) {
        return this.apiService.apiRequest<ILeadsReportsDataResponse>({
            method: 'get',
            url: `/api/v2/reporting/users/${userId}/reports/leads`,
            params: user_data
        });
    }
    async getSummaryReportsData(
        userId: string,
        user_data: ILeadsReportsParams
    ) {
        return this.apiService.apiRequest<ISummaryResponse>({
            method: 'get',
            url: `/api/v2/reporting/users/${userId}/reports/totals`,
            params: user_data
        });
    }

    async getReportAnalytics(
        userId: string,
        filters?: ReportFiltersType
    ): Promise<IReportDataResponse> {
        return this.apiService.apiRequest<IReportDataResponse>({
            method: 'get',
            url: `/api/v2/reporting/users/${userId}/reports/analytics`,
            params: {
                source: 'reports',
                tag_ids: filters?.tags,
                project_type_ids: filters?.projectTypes
            }
        });
    }
    async getReportSales(
        userId: string,
        filters?: ReportFiltersType
    ): Promise<IReportDataResponse> {
        return this.apiService.apiRequest<IReportDataResponse>({
            method: 'get',
            url: `/api/v2/reporting/users/${userId}/reports/sales`,
            params: {
                source: 'reports',
                tag_ids: filters?.tags,
                project_type_ids: filters?.projectTypes
            }
        });
    }

    async getReportSalesCsv(userId: string): Promise<ISalesReportsCsvResponse> {
        return this.apiService.apiRequest<ISalesReportsCsvResponse>({
            method: 'get',
            url: `/api/v2/reporting/users/${userId}/reports/csv/sales`,
            params: {
                source: 'reports'
            }
        });
    }

    async getUsersAccountTransactions(
        userId: string,
        source: string = 'unknown'
    ) {
        // TODO: fix type
        return this.apiService.apiRequest<any>({
            method: 'get',
            url: `/api/v2/reporting/users/${userId}/reports/transactions`,
            params: {
                source
            }
        });
    }
}
